<template>
  <div v-bind="$attrs" data-popper-arrow role="presentation"></div>
</template>

<script lang="ts">
export default {
  name: 'SbPopoverArrow',
}
</script>
